export default __webpack_public_path__ + "static/media/ninth-strip.e64ce88d.png";